import PermissionButton from '../../permissions/PermissionButton';
import React, { useState, useRef } from 'react';
import { Card, Table, Input, Button, Space, Drawer, Tag } from 'antd';
import { SearchOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { useFetchAllFours } from '../../hooks/fourHooks';
import FourForm from './FourForm';

const FourList = ({ onSelectFour }) => {
  const { Fours, loading, error, refetch } = useFetchAllFours();
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Rechercher
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Réinitialiser
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current && searchInput.current.select());
      }
    },
    render: text => text
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  if (loading) return <p>Chargement...</p>;
  if (error) return <p>Erreur: {error}</p>;

  const columns = [
    {
      title: 'Compte',
      dataIndex: 'compte',
      key: 'compte',
      ...getColumnSearchProps('compte', 'Rechercher par compte'),
    },
    {
      title: 'Raison Sociale',
      dataIndex: 'sociale',
      key: 'sociale',
      ...getColumnSearchProps('sociale', 'Rechercher par nom'),
    },
    {
      title: 'Pays',
      dataIndex: 'pays',
      key: 'pays',
      ...getColumnSearchProps('pays', 'Rechercher par pays'),
    },
    {
      title: 'Statut',
      dataIndex: 'bloquer',
      key: 'bloquer',
      render: (bloquer) => (
        <Tag color={bloquer ? 'red' : 'green'}>
          {bloquer ? 'Bloqué' : 'Actif'}
        </Tag>
      ),
    },
  ];

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "16px",
    borderBottom: "2px solid #ccc",
    paddingBottom: "10px",
    marginTop: "-10px",
  };

  const tableCardStyle = {
    marginTop: "20px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  };

  const handleCreated = () => {
    setIsCreateOpen(false);
    refetch && refetch();
  };

  return (
    <div>
      <Card style={tableCardStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <h2 style={titleStyle}>Liste des Fournisseurs</h2>
            <Button
              type="text"
              icon={<ReloadOutlined />}
              onClick={() => refetch && refetch()}
              title="Actualiser"
            />
          </div>
          <PermissionButton permissionModule="suppliers" permissionAction="create" type="primary" icon={<PlusOutlined />} onClick={() => setIsCreateOpen(true)}>
            Ajouter Fournisseur
          </PermissionButton>
        </div>
        <Table
          columns={columns}
          dataSource={Fours}
          rowKey="code_frs"
          pagination={{ pageSize: 10 }}
          onRow={(record) => ({
            onClick: () => onSelectFour && onSelectFour(record),
            style: { cursor: 'pointer' }
          })}
          size="small"
        />
      </Card>
      <Drawer
        title="Nouveau Fournisseur"
        placement="right"
        width={640}
        open={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
        destroyOnClose
      >
        <FourForm onSuccess={handleCreated} />
      </Drawer>
    </div>
  );
};

export default FourList;
